import { useEffect, useState } from 'react';
import EntryGate from './components/EntryGate';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Loader from './components/Loader';
import Philosophy from './components/Philosophy';
import Transition from './components/Transition';
import SignatureWork from './components/SignatureWork';
import Capabilities from './components/Capabilities';
import Standards from './components/Standards';
import ClientTrust from './components/ClientTrust';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [showEntryGate, setShowEntryGate] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleEntryComplete = () => {
    setShowEntryGate(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2800);
  };

  if (showEntryGate) {
    return <EntryGate onComplete={handleEntryComplete} />;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="bg-[#FAFAF8]">
      <Navbar />
      <Hero />
      <Philosophy />
      <Transition />
      <SignatureWork />
      <Capabilities />
      <Standards />
      <ClientTrust />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
